import React from 'react';

import TextField from '@material-ui/core/TextField';

const TextInputControl = ({
  value,
  onChange,
  onTouch,
  validationState,
  errorMessages,
  ...restOfProps
}) => {
  const { dirty, pending, touched, valid, ...restOfValidation } = validationState;

  const hasError = (dirty || touched) && !valid;

  const errors = Object.keys(restOfValidation).reduce((prev, key) => {
    if (!restOfValidation[key]) {
      return [...prev, errorMessages[key]];
    }
    return prev;
  }, []);

  const handleChange = e => {
    onChange(e.target.value === '' ? null : e.target.value);
  };

  return (
    <TextField
      value={value || ''}
      onChange={handleChange}
      onBlur={() => onTouch()}
      error={hasError}
      helperText={hasError ? errors.join(', ') : undefined}
      {...restOfProps}
    />
  );
};

export default TextInputControl;
